// extracted by mini-css-extract-plugin
export var quillEditor = "_pf-1";
export var variable = "_pf-0";